export default __webpack_public_path__ + "static/media/kanipakamPlacesOne.ad473baf.png";